import PropTypes from 'prop-types';
import React from 'react';
import Highlighter from 'react-highlight-words';

import { globalTheme } from '@playbookux/playbook-web-core';
import {
  Card,
  ContainerBottom,
  FirstName,
  TaskName,
  VideoLink,
} from './styles';

const QuotesCard = (props) => {
  const { firstName } = props;

  return (
    <Card>
      <Highlighter
        autoEscape
        highlightStyle={{
          backgroundColor: globalTheme.color.highlight,
          color: globalTheme.color.highlightWordColor,
          fontSize: 14,
        }}
        searchWords={props.highlight}
        textToHighlight={props.children}
      />

      <ContainerBottom>
        <TaskName>
          {props.taskName}
          {' '}
          (
          {props.taskDuration}
          )
        </TaskName>
        <FirstName>
          <VideoLink onClick={props.onVideoLinkClicked}>{firstName}</VideoLink>
        </FirstName>
      </ContainerBottom>
    </Card>
  );
};

QuotesCard.propTypes = {
  children: PropTypes.string.isRequired,
  highlight: PropTypes.array.isRequired,
  taskDuration: PropTypes.string.isRequired,
  taskName: PropTypes.string.isRequired,
  onVideoLinkClicked: PropTypes.func.isRequired,
  firstName: PropTypes.string.isRequired,
};

export default QuotesCard;
